import { Table, TableRow, TableCell, Paragraph, TextRun, WidthType, TableLayoutType } from 'docx';
import { BORDER_COLOR, HEADER_FILL_COLOR } from './constants';
import { DEFAULT_CONTENT_WIDTH } from './utils';

export const createDelillerTable = (delillerInfo, contentWidth = DEFAULT_CONTENT_WIDTH) => {
  return new Table({
    width: { size: contentWidth, type: WidthType.DXA },
    layout: TableLayoutType.FIXED,
    columnWidths: [contentWidth],
    borders: {
      top: { style: 'single', size: 1, color: BORDER_COLOR },
      bottom: { style: 'single', size: 1, color: BORDER_COLOR },
      left: { style: 'single', size: 1, color: BORDER_COLOR },
      right: { style: 'single', size: 1, color: BORDER_COLOR },
      insideHorizontal: { style: 'single', size: 1, color: BORDER_COLOR },
      insideVertical: { style: 'single', size: 1, color: BORDER_COLOR },
    },
    rows: [
      new TableRow({
        children: [
          new TableCell({
            width: { size: contentWidth, type: WidthType.DXA },
            children: [new Paragraph({
              children: [
                new TextRun({
                  text: "Deliller",
                  bold: true
                })
              ]
            })],
            shading: { fill: HEADER_FILL_COLOR },
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({ width: { size: contentWidth, type: WidthType.DXA }, children: [new Paragraph(delillerInfo || "")] }),
        ],
      }),
    ],
  });
};